import { isHolidayForDate } from './isHolidayForDate';
import type { FindHolidayForDateParams } from './types';

export function getBranchHolidaysForDate({ branch, date }: FindHolidayForDateParams) {
    if (!branch.holidays.length) {
        return undefined;
    }
    return branch.holidays.find((holiday) => isHolidayForDate({ holiday, date }));
}
